/**
 * SubtabFrame.jsx
 * ---------------------------------------------------------------------------
 * Shared content scaffold for subtabs IV–XV (the technical depth pages).
 * All of those pages follow an identical structure:
 *   heading → diagram → "The gap" italic block → "Best-in-class solution"
 *   bold lead → body paragraphs.
 *
 * Subtabs I–III have bespoke layouts and don't use this frame.
 */

import React from "react";
import { cxTokens as t } from "../../lib/coconsolexTokens.js";

export function SubtabHeading({ roman, children }) {
  return (
    <header style={{ marginBottom: 28 }}>
      <div
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontStyle: "italic",
          fontSize: 14,
          color: t.slate,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          marginBottom: 12,
        }}
      >
        Subtab {roman}
      </div>
      <h1
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 500,
          fontSize: "clamp(30px, 4vw, 44px)",
          margin: 0,
          color: t.ink,
          lineHeight: 1.1,
          letterSpacing: "-0.01em",
        }}
      >
        {children}
      </h1>
    </header>
  );
}

export function GapBlock({ children }) {
  return (
    <div
      style={{
        borderLeft: `2px solid ${t.rule}`,
        padding: "12px 0 12px 18px",
        margin: "24px 0",
        fontFamily: "'Cormorant Garamond', serif",
        fontStyle: "italic",
        fontSize: 18,
        color: t.slate,
        lineHeight: 1.6,
      }}
    >
      <strong
        style={{
          fontStyle: "normal",
          fontFamily: "'Inter', sans-serif",
          fontSize: 11,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          color: t.ink,
          display: "block",
          marginBottom: 6,
        }}
      >
        The gap
      </strong>
      {children}
    </div>
  );
}

export function SolutionLead({ children }) {
  return (
    <div style={{ margin: "24px 0 28px" }}>
      <div
        style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: 11,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          color: t.slate,
          marginBottom: 8,
        }}
      >
        Best-in-class solution
      </div>
      <p
        style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: 18,
          fontWeight: 600,
          color: t.ink,
          lineHeight: 1.5,
          margin: 0,
        }}
      >
        {children}
      </p>
    </div>
  );
}

export function Body({ children }) {
  return (
    <div
      style={{
        fontFamily: "'Inter', sans-serif",
        fontSize: 16,
        lineHeight: 1.75,
        color: t.ink,
      }}
    >
      {children}
    </div>
  );
}

export function P({ children }) {
  return <p style={{ margin: "0 0 18px 0" }}>{children}</p>;
}
